import { c as _c } from "react/compiler-runtime";
import { Trans, useTranslation } from 'react-i18next';
import React, { ReactNode } from 'react';
import Floating from '@/sections/Floating';
import { Link } from '@/components/links';
import { LINKS } from '@/constants/links';
import IconDeferredPayment from '@/assets/icons/heroIcons/Deferred-payment.svg';
import IconExtend from '@/assets/icons/heroIcons/Extend.svg';
import IconRewards from '@/assets/icons/heroIcons/Rewards.svg';
function Title(t0) {
  const $ = _c(5);
  const {
    icon,
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <span>{title}</span>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== icon || $[3] !== t1) {
    t2 = <span className="flex flex-row gap-3 lg:gap-4 [&>svg]:h-7 [&>svg]:w-7 lg:[&>svg]:h-12 lg:[&>svg]:w-12">{icon}{t1}</span>;
    $[2] = icon;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function Content(t0) {
  const $ = _c(7);
  const {
    title,
    text
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <p className="mb-3 font-semibold lg:mb-4">{title}</p>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== text) {
    t2 = <p>{text}</p>;
    $[2] = text;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div>{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
export function Benefits() {
  const $ = _c(75);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["retention"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <><div className="bgCircle absolute right-0 bottom-0 hidden translate-x-2/3 translate-y-10 lg:block" /><div className="bgCircle absolute top-1/3 left-0 hidden -translate-x-1/4 -translate-y-1/3 rotate-90 lg:block" /></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("benefits.items.1.subtitle");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("benefits.items.1.text");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <Content title={t2} text={t3} />;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("benefits.items.1.title");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <IconDeferredPayment />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5) {
    t7 = <Title title={t5} icon={t6} />;
    $[12] = t5;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("benefits.items.1.title");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = {
      alt: t8,
      src: "/images/sections/retention/benefits/1.png"
    };
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t4 || $[19] !== t7 || $[20] !== t9) {
    t10 = {
      anchorKey: "benefits.items.1.title",
      content: t4,
      title: t7,
      image: t9,
      variant: "small"
    };
    $[18] = t4;
    $[19] = t7;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t) {
    t11 = t("benefits.items.3.subtitle");
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t) {
    t12 = t("benefits.items.3.text");
    $[24] = t;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t11 || $[27] !== t12) {
    t13 = <Content title={t11} text={t12} />;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t) {
    t14 = t("benefits.items.3.title");
    $[29] = t;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <IconExtend />;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t14) {
    t16 = <Title title={t14} icon={t15} />;
    $[32] = t14;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t) {
    t17 = t("benefits.items.3.title");
    $[34] = t;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== t17) {
    t18 = {
      alt: t17,
      src: "/images/sections/retention/benefits/3.png"
    };
    $[36] = t17;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== t13 || $[39] !== t16 || $[40] !== t18) {
    t19 = {
      anchorKey: "benefits.items.3.title",
      content: t13,
      title: t16,
      image: t18,
      imagePosition: "right",
      variant: "small"
    };
    $[38] = t13;
    $[39] = t16;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t) {
    t20 = t("benefits.items.4.subtitle");
    $[42] = t;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Link analyticsParam="retentionRewards" testId="retentionRewards" to={LINKS().rewards} className="text-white!" />;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t) {
    t22 = <Trans t={t} i18nKey="benefits.items.4.text">{t21}</Trans>;
    $[45] = t;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== t20 || $[48] !== t22) {
    t23 = <Content title={t20} text={t22} />;
    $[47] = t20;
    $[48] = t22;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== t) {
    t24 = t("benefits.items.4.title");
    $[50] = t;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <IconRewards />;
    $[52] = t25;
  } else {
    t25 = $[52];
  }
  let t26;
  if ($[53] !== t24) {
    t26 = <Title title={t24} icon={t25} />;
    $[53] = t24;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  let t27;
  if ($[55] !== t) {
    t27 = t("benefits.items.4.title");
    $[55] = t;
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  let t28;
  if ($[57] !== t27) {
    t28 = {
      alt: t27,
      src: "/images/sections/retention/benefits/4.png"
    };
    $[57] = t27;
    $[58] = t28;
  } else {
    t28 = $[58];
  }
  let t29;
  if ($[59] !== t23 || $[60] !== t26 || $[61] !== t28) {
    t29 = {
      anchorKey: "benefits.items.4.title",
      content: t23,
      title: t26,
      image: t28,
      variant: "small"
    };
    $[59] = t23;
    $[60] = t26;
    $[61] = t28;
    $[62] = t29;
  } else {
    t29 = $[62];
  }
  let t30;
  if ($[63] !== t10 || $[64] !== t19 || $[65] !== t29) {
    t30 = [t10, t19, t29];
    $[63] = t10;
    $[64] = t19;
    $[65] = t29;
    $[66] = t30;
  } else {
    t30 = $[66];
  }
  let t31;
  if ($[67] !== t) {
    t31 = t("benefits.title");
    $[67] = t;
    $[68] = t31;
  } else {
    t31 = $[68];
  }
  let t32;
  if ($[69] !== t) {
    t32 = t("benefits.text");
    $[69] = t;
    $[70] = t32;
  } else {
    t32 = $[70];
  }
  let t33;
  if ($[71] !== t30 || $[72] !== t31 || $[73] !== t32) {
    t33 = <Floating headerClassName="max-w-none!" bgCircles={t1} boxes={t30} title={t31} subtitle={t32} />;
    $[71] = t30;
    $[72] = t31;
    $[73] = t32;
    $[74] = t33;
  } else {
    t33 = $[74];
  }
  return t33;
}